module.exports = __webpack_public_path__ + "img/taiz2.769bede1.png";